/**
 * ClemtexBrands — shopping entry point.
 *
 * Manufacturer landing pages: clemtex.com/<slug> is the normal results page
 * filtered to one Web Manufacturer, with
 *   - the Manufacturer filter (and its chip) hidden,
 *   - the template's path-scoped content area (item_list_banner_top) free for
 *     per-brand HTML placed with Site Management Tools,
 *   - brand-scoped category tiles and drill-down (clemtex.com/<slug>/blast/...).
 * Plus shop-by-brand navigation: the All Items dropdown and a /brands page.
 *
 * Brands and settings live in the SuiteCommerce Configuration record
 * (Extensions > Clemtex Brand Pages); adding a manufacturer is one table row.
 * A brand home's intro and card navigation come from Brand Page records in
 * NetSuite (Clemtex.Brands.Home), via the "Brand page content URL" setting.
 */
define('Clemtex.Brands', [
    'Clemtex.Brands.Utils',
    'Clemtex.Brands.Browse',
    'Clemtex.Brands.Menu',
    'Clemtex.Brands.FacetUrls',
    'Utils'
], function (Utils, Browse, Menu, FacetUrls, SCUtils) {
    'use strict';

    // Logo values like "img/brand-logo-clemco.png" are files shipped in this
    // extension; getExtensionAssetsPath is injected by the extension build.
    function resolveAsset(path) {
        /* global getExtensionAssetsPath */
        if (typeof getExtensionAssetsPath !== 'function') { return path; }
        var relative = getExtensionAssetsPath(path);
        return SCUtils && SCUtils.getAbsoluteUrl ? SCUtils.getAbsoluteUrl(relative) : '/' + relative;
    }

    return {
        mountToApp: function mountToApp(container) {
            var config = {};
            var settings;
            try {
                var environment = container.getComponent('Environment');
                config = (environment && environment.getConfig('clemtexBrands')) || {};
                var minItems = parseInt(config.minItems, 10);
                var menuColumns = parseInt(config.menuColumns, 10);
                var facetUrls = FacetUrls.buildAliasMap(config.facetUrlNames);
                if (facetUrls.skipped.length && window.console) {
                    window.console.warn('ClemtexBrands: facet URL names skipped: ' + facetUrls.skipped.join('; '));
                }
                settings = {
                    minItems: isNaN(minItems) ? 2 : Math.max(1, minItems),
                    skipSingle: config.skipSingleTileLevels !== false,
                    excludeUrls: Utils.parseExcludeList(config.excludeCategoryUrls),
                    siteName: config.siteName === undefined ? 'Clemtex' : String(config.siteName || ''),
                    menuInDropdown: config.menuInDropdown !== false,
                    menuColumns: isNaN(menuColumns) ? 5 : Math.min(8, Math.max(1, menuColumns)),
                    contentUrl: String(config.contentUrl || '').trim(),
                    facetUrls: facetUrls
                };
                Browse.install(Utils.buildBrandMap(config.brands, resolveAsset), settings, container.getComponent('PageType'));
            } catch (e) {
                if (window.console) { window.console.error('ClemtexBrands mount failed', e); }
            }
            try {
                Menu.install(Utils.buildMenu(config.brands, resolveAsset), settings || { menuInDropdown: true, menuColumns: 5, siteName: 'Clemtex' },
                    container.getComponent('PageType'), container.getComponent('Layout'));
            } catch (e2) {
                if (window.console) { window.console.error('ClemtexBrands menu mount failed', e2); }
            }
        }
    };
});
